import React, { useRef } from 'react';
import Spinner from './Spinner';
import '@reach/tooltip/styles.css';
import type { Tooltip as TooltipType } from '@reach/tooltip';
const Tooltip = React.lazy<typeof TooltipType>(() => import('@reach/tooltip'));

interface IconWithTooltipProps {
	renderIcon: () => React.ReactNode;
	tooltipText: string;
}

/**
 * Reusable component for rendering an icon inside a tooltip wrapper with text.
 *
 * @export
 * @param {ShoppingListIconProps} props
 */
export default function IconWithTooltip(props: IconWithTooltipProps) {
	const { renderIcon, tooltipText } = props;
	const containerRef = useRef<HTMLButtonElement>(null);

	return (
		<React.Suspense fallback={<Spinner />}>
			<Tooltip label={tooltipText} as={'div'}>
				<button ref={containerRef} type="button" className="roc-icon-with-tooltip" aria-label={tooltipText}>
					<span className="roc-icon-with-tooltip__icon-wrapper">{renderIcon()}</span>
				</button>
			</Tooltip>
		</React.Suspense>
	);
}
